(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["supermen-gave-kurv"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.SupermenGaveKurv) return;
    window.SupermenGaveKurv = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var koe = Promise.resolve(), venter = 0;

    function knapper() { return Array.prototype.slice.call(document.querySelectorAll('[data-spd-gave-linje]')); }
    var husk = 'giftwrap';
    function noegle() { var k = knapper()[0]; if (k && k.dataset.noegle) husk = k.dataset.noegle; return husk; }
    function navn(it) { return it.title || it.product_title; }
    function titler(cart, n) {
      var v = String((cart.attributes || {})[n] || ''), t = [], m;
      var re = /\s*(.+?) \(x\d+\)\s*(?:,|$)/g;
      while ((m = re.exec(v))) if (t.indexOf(m[1]) < 0) t.push(m[1]);
      if (!t.length && v.trim()) v.split(',').forEach(function (d) { d = d.trim(); if (d && t.indexOf(d) < 0) t.push(d); });
      return t;
    }
    function gem(cart, n, liste) {
      var tekst = cart.items.filter(function (it) { return liste.indexOf(navn(it)) > -1; })
        .map(function (it) { return navn(it) + ' (x' + it.quantity + ')'; }).join(', ');
      if (tekst === String((cart.attributes || {})[n] || '')) return Promise.resolve(cart);
      var a = {};
      a[n] = tekst;
      return fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: a })
      }).then(function (r) { if (!r.ok) throw new Error('giftwrap'); return r.json(); });
    }
    function hent() {
      return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    }
    function saet(k, paa) { k.setAttribute('aria-pressed', paa ? 'true' : 'false'); }
    function vis(cart, n) {
      var liste = titler(cart, n);
      knapper().forEach(function (k) { saet(k, liste.indexOf(k.dataset.titel) > -1); });
    }
    // Gemmer ét valg ad gangen, så hurtige klik på flere varer ikke overskriver hinanden.
    // Går det galt, vises det, der faktisk ligger i kurven.
    function iKoe(job, n) {
      venter++;
      koe = koe.then(job).then(function (cart) {
        if (venter === 1 && cart) vis(cart, n);
      }, function () {
        return hent().then(function (cart) { if (venter === 1) vis(cart, n); }).catch(function () {});
      }).then(function () { venter--; });
    }

    // Knappen skifter med det samme; gemningen sker bagefter
    document.addEventListener('click', function (e) {
      var k = e.target.closest && e.target.closest('[data-spd-gave-linje]');
      if (!k) return;
      var n = k.dataset.noegle || 'giftwrap', titel = k.dataset.titel, paa = k.getAttribute('aria-pressed') !== 'true';
      knapper().forEach(function (x) { if (x.dataset.titel === titel) saet(x, paa); });
      k.classList.remove('is-pop');
      if (paa) { void k.offsetWidth; k.classList.add('is-pop'); }
      // Valget fra klikket gemmes (ikke knappens tilstand senere: kurvsiden kan være tegnet igen imens)
      iKoe(function () {
        return hent().then(function (cart) {
          var liste = titler(cart, n), i = liste.indexOf(titel);
          if (paa && i < 0) liste.push(titel);
          if (!paa && i > -1) liste.splice(i, 1);
          return gem(cart, n, liste);
        });
      }, n);
    });

    // Antal ændret eller vare fjernet på kurvsiden: "(x2)" i feltet følger med.
    // Kurven hentes frisk: kurven i hændelsen kan være ældre end et gavevalg, der er gemt imens.
    // Er den sidste vare fjernet, er der ingen knapper tilbage, men feltet skal stadig tømmes.
    document.addEventListener('cart:update', function (e) {
      var c = e.detail && e.detail.resource;
      if (!knapper().length && !(c && c.item_count === 0)) return;
      var n = noegle();
      iKoe(function () {
        return hent().then(function (cart) {
          return gem(cart, n, titler(cart, n));
        });
      }, n);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["supermen-kort"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.SupermenKortStr) return;
    window.SupermenKortStr = true;
    // Baren under billederne følger med, når man swiper
    document.addEventListener('scroll', function (e) {
      var l = e.target;
      if (!l.classList || !l.classList.contains('spd-kort__link--glid')) return;
      l.classList.add('er-vist');
      var bar = l.parentNode.querySelector('.spd-kort__bar');
      if (bar && l.clientWidth) bar.style.setProperty('--i', Math.round(l.scrollLeft / l.clientWidth));
    }, { capture: true, passive: true });
    // Rører man ved billedet, hentes resten af billederne, før man når at swipe
    function rort(e) {
      var l = e.target.closest && e.target.closest('.spd-kort__link--glid');
      if (l) l.classList.add('er-vist');
    }
    document.addEventListener('touchstart', rort, { capture: true, passive: true });
    document.addEventListener('pointerdown', rort, { capture: true, passive: true });
    // Størrelserne ligger gemt bag pilen nederst på billedet, så varen kan ses i ro
    function aabn(kort, vis, fokus) {
      if (!kort) return;
      var knap = kort.querySelector('[data-spd-aabn]');
      kort.classList.toggle('is-str', vis);
      if (knap) knap.setAttribute('aria-expanded', vis ? 'true' : 'false');
      if (!fokus) return;
      if (vis) { var f = kort.querySelector('.spd-kort__str button:not([disabled])'); if (f) f.focus({ preventScroll: true }); }
      else if (knap) knap.focus({ preventScroll: true });
    }
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      // Fokus flyttes kun ved tastatur (detail 0), så en række ikke ruller væk under musen
      var a = e.target.closest('[data-spd-aabn]');
      if (a) { e.preventDefault(); aabn(a.closest('.spd-kort'), true, e.detail === 0); return; }
      var l = e.target.closest('[data-spd-luk]');
      if (l) { e.preventDefault(); aabn(l.closest('.spd-kort'), false, e.detail === 0); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !e.target.closest) return;
      var kort = e.target.closest('.spd-kort.is-str');
      if (kort) { e.preventDefault(); aabn(kort, false, true); }
    });
    // Lukker igen, når musen eller fokus forlader kortet
    document.addEventListener('mouseout', function (e) {
      // Ikke mens en knap holdes nede: rækkerne fanger musen, når man trækker i dem
      if (e.buttons) return;
      var kort = e.target.closest && e.target.closest('.spd-kort.is-str');
      if (!kort || (e.relatedTarget && kort.contains(e.relatedTarget))) return;
      var tast = document.activeElement && kort.contains(document.activeElement) && document.activeElement.matches(':focus-visible');
      if (tast) return;
      setTimeout(function () { if (!kort.matches(':hover')) aabn(kort, false, false); }, 200);
    });
    document.addEventListener('focusout', function (e) {
      var kort = e.target.closest && e.target.closest('.spd-kort.is-str');
      if (kort && e.relatedTarget && !kort.contains(e.relatedTarget)) aabn(kort, false, false);
    });
    // Størrelsen vælges først; knappen "Læg i kurv" får så varianten og lægger den i kurven
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.spd-kort__hurtig [data-spd-valg]');
      if (!b || b.disabled) return;
      e.preventDefault();
      var g = b.closest('.spd-kort__hurtig');
      Array.prototype.forEach.call(g.querySelectorAll('[data-spd-valg]'), function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      var knap = g.querySelector('.spd-kort__laeg');
      knap.dataset.spdAdd = b.dataset.spdValg;
      knap.dataset.spdValgNavn = b.textContent.trim();
      knap.disabled = false;
      knap.classList.remove('is-ok');
      knap.setAttribute('aria-label', 'Læg ' + (g.dataset.navn || '') + ', ' + b.textContent.trim() + ' i kurven');
    });

    /* Læg i kurv fra kortet virker på alle sider, også forsiden og søgesiden.
       Varebilledet flyver op i kurven, og kortet "Lagt i kurven" kommer frem (snippets/supermen-kurv-kort, fra headerens kurv).
       På produktsiden sørger Supermen vare for det. Er kortet slået fra, åbner headerens mini-kurv, eller der kommer en kort besked. */
    var R = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    function esc(s) {
      return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
    }
    var besked, beskedT;
    function vis(html, fejl) {
      if (!besked) {
        besked = document.createElement('div');
        besked.className = 'spd spd-toast';
        besked.setAttribute('role', 'status');
        besked.setAttribute('aria-live', 'polite');
        document.body.appendChild(besked);
      }
      besked.innerHTML = html;
      besked.classList.toggle('is-fejl', !!fejl);
      void besked.offsetWidth;
      besked.classList.add('is-vist');
      window.clearTimeout(beskedT);
      beskedT = window.setTimeout(function () { besked.classList.remove('is-vist'); }, 4500);
    }
    // Kortets billede flyver op i kurven, når det kan ses
    function kortBillede(kort) {
      var m = kort && kort.querySelector('.spd-kort__media');
      if (!m) return null;
      var r = m.getBoundingClientRect();
      var h = Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0), w = Math.min(r.right, window.innerWidth) - Math.max(r.left, 0);
      return h > 0 && w > 0 && h * w > 15000 ? m : null;
    }
    function tilfoej(knap) {
      if (knap.classList.contains('is-busy')) return;
      var kort = knap.closest('.spd-kort');
      var navn = kort && kort.querySelector('.spd-kort__navn');
      navn = navn && navn.firstChild ? navn.firstChild.textContent.trim() : '';
      var items = [{ id: +knap.dataset.spdAdd, quantity: 1 }];
      knap.classList.add('is-busy');
      function ok() {
        knap.classList.remove('is-busy');
        knap.classList.add('is-ok');
        window.setTimeout(function () { knap.classList.remove('is-ok'); }, 2400);
      }
      function fejl(msg) {
        knap.classList.remove('is-busy');
        vis(esc(msg || 'Varen kunne ikke lægges i kurven. Prøv igen.'), true);
      }
      if (document.querySelector('[data-spd-vare][data-ready]')) {
        document.dispatchEvent(new CustomEvent('supermen:add', { detail: { items: items, onSuccess: ok, onError: fejl } }));
        return;
      }
      var svar = null;
      fetch(R + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || 'Varen kunne ikke lægges i kurven. Prøv igen.');
          svar = j;
        });
      }).then(function () {
        // Varen er lagt i kurven nu. Fejler hentningen af kurven bagefter, vises beskeden alligevel.
        return fetch(R + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).catch(function () { return null; });
      }).then(function (cart) {
        ok();
        var kk = window.SupermenKurvKort;
        if (cart && cart.items && kk && kk.klar('kort')) {
          kk.vis({ svar: svar, cart: cart, fra: knap, stort: kortBillede(kort), kilde: 'supermen-kort' }).catch(function () {});
          return;
        }
        var str = knap.dataset.spdValgNavn ? ', ' + knap.dataset.spdValgNavn : '';
        // Headerens mini-kurv viser varen, når headeren kan ses (Supermen header). Ellers kommer beskeden.
        var mk = document.querySelector('[data-shd-minikurv][data-ved-tilfoej="true"]');
        var mkBar = mk && mk.closest('[data-shd-bar]');
        var mini = !!(cart && mkBar && mkBar.getBoundingClientRect().bottom > 0);
        if (cart) document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'supermen-kort', data: { source: 'supermen-kort', itemCount: cart.item_count, navn: navn + str, mini: mini } } }));
        if (!mini) vis('<svg class="spd-ikon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg><span>' + esc(navn + str) + ' er lagt i kurven.</span><a href="' + R + 'cart">Se kurven</a>');
      }).catch(function (e) { fejl(e instanceof TypeError ? 'Varen kunne ikke lægges i kurven. Tjek din forbindelse, og prøv igen.' : e.message); });
    }
    document.addEventListener('click', function (e) {
      var k = e.target.closest && e.target.closest('.spd-kort [data-spd-add]');
      if (!k || k.disabled || !k.dataset.spdAdd) return;
      // Rækkerne på produktsiden klarer det selv. Det samme gør den ældre kode i blokken Produktkort, hvis den stadig er i temaet.
      if (k.closest('[data-spd-mere]') || window.SupermenKortblok === true) return;
      e.preventDefault();
      tilfoej(k);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["supermen-kurv-kort"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.SupermenKurvKort) return;
    var R = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/');
    var rod = null, kk = null, skygge = null, meld = null, ikonOk = '';
    var noegler = [], retur = null, opt = {};
    var normal = {}, hentet = {};
    var mobil = window.matchMedia('(max-width: 860px)');
    var rolig = window.matchMedia('(prefers-reduced-motion: reduce)');
    // Det sidste, kunden trykkede på: billedet flyver derfra, når der ikke er sagt andet
    var tryk = null, trykTid = 0;
    document.addEventListener('pointerdown', function (e) { tryk = e.target; trykTid = Date.now(); }, true);

    function money(cents) {
      return (cents / 100).toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' kr';
    }
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function all(el, s) { return Array.prototype.slice.call(el.querySelectorAll(s)); }
    function $(s) { return kk.querySelector(s); }
    function hentKurv() {
      return fetch(R + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    }

    // Kortet ligger i headerens kurv-blok og flyttes ud på siden, så headerens bevægelser ikke rykker det
    function find() {
      if (rod && rod.isConnected) return rod;
      var r = document.querySelector('[data-spd-kk-rod]');
      if (!r) return null;
      if (r.parentNode !== document.body) document.body.appendChild(r);
      r.hidden = false;
      rod = r;
      kk = r.querySelector('[data-spd-kk]');
      skygge = r.querySelector('[data-spd-kk-skygge]');
      meld = r.querySelector('[data-spd-kk-meld]');
      var ok = kk.querySelector('.spd-kk__ok');
      ikonOk = ok ? ok.innerHTML : '';
      bind();
      return rod;
    }

    // Navn uden brand og farven for sig, med samme regler som snippets/supermen-navn og kurven
    function navnDele(titel, brand, type) {
      var t = titel || '', farve = '';
      if (brand && t.toLowerCase().indexOf(brand.toLowerCase() + ' ') === 0) t = t.slice(brand.length + 1).replace(/^[-–]\s*/, '');
      var fm = t.match(/^(.+?)\s+[-–\/]\s+(.+)$/) || t.match(/^(.*[a-zæøå].*?)\s+([A-ZÆØÅ0-9][A-ZÆØÅ0-9 ]*[A-ZÆØÅ])$/);
      if (fm && !(type && fm[2].toLowerCase().indexOf(type.toLowerCase()) > -1)) {
        t = fm[1];
        farve = fm[2];
        if (farve === farve.toUpperCase()) farve = farve.toLowerCase().replace(/(^|\s)\S/g, function (c) { return c.toUpperCase(); });
      }
      return { titel: t.replace(/\s+[-–]\s+/g, ' '), farve: farve };
    }
    function billede(u, w) {
      if (!u) return '';
      return u.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '') + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
    }
    // Normalpris først, så den nedsatte pris
    function prisHtml(foer, nu) {
      return foer > nu ? '<span class="spd-kk-pris is-ned"><s><span class="spd-sr">Normalpris </span>' + money(foer) + '</s><b><span class="spd-sr">Nu </span>' + money(nu) + '</b></span>'
        : '<span class="spd-kk-pris"><b>' + money(nu) + '</b></span>';
    }

    function graense() {
      return opt.fri != null ? +opt.fri || 0 : +rod.dataset.fri || 0;
    }
    function fragtSum(cart) {
      var sendes = false, uden = 0;
      cart.items.forEach(function (it) { if (it.requires_shipping) sendes = true; else uden += it.final_line_price || 0; });
      return { sendes: sendes, sum: Math.max(0, cart.total_price - uden) };
    }

    /* Kurven kender kun prisen, varen koster nu. Normalprisen (førpris) hentes fra varen, så den kan stå først. */
    function hentNormal(cart) {
      var jobs = [];
      cart.items.forEach(function (it) {
        var h = it.handle;
        if (!h || hentet[h]) return;
        hentet[h] = fetch(R + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : {}; })
          .then(function (p) { (p.variants || []).forEach(function (v) { normal[v.id] = v.compare_at_price || 0; }); })
          .catch(function () {});
        jobs.push(hentet[h]);
      });
      // Venter højst lidt over et sekund, så kortet aldrig hænger på det
      return Promise.race([Promise.all(jobs), new Promise(function (ok) { window.setTimeout(ok, 1200); })]).then(function () { return cart; });
    }
    function foerPris(it) {
      var n = (normal[it.variant_id || it.id] || 0) * it.quantity;
      return Math.max(it.original_line_price || 0, n);
    }
    function linje(it) {
      var d = navnDele(it.product_title, it.vendor, it.product_type);
      var opts = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
      if (/ /.test(opts) && opts === opts.toUpperCase() && /[A-ZÆØÅ]/.test(opts)) opts = opts.charAt(0) + opts.slice(1).toLowerCase();
      var info = [d.farve, opts].filter(Boolean).join(' · ') + (it.quantity > 1 ? (d.farve || opts ? ', ' : '') + it.quantity + ' stk.' : '');
      return '<div class="spd-kk-linje">' +
        '<span class="spd-kk-linje__img">' + (it.image ? '<img src="' + esc(billede(it.image, 160)) + '" alt="" loading="lazy">' : '') + '</span>' +
        '<div><a href="' + esc(it.url) + '">' + esc(d.titel) + '</a><small>' + esc(info) + '</small></div>' +
        prisHtml(foerPris(it), it.final_line_price) + '</div>';
    }
    // Øverst det, der er lagt i nu. Under det, mindre, det kunden havde i kurven i forvejen.
    function linjer(cart, nye) {
      var box = $('[data-spd-kk-linjer]');
      var vis = noegler.map(function (k) { return cart.items.filter(function (it) { return it.key === k; })[0]; }).filter(Boolean);
      var foer = cart.items.filter(function (it) { return noegler.indexOf(it.key) < 0; });
      var max = 4, rest = foer.length - max;
      var kurvUrl = ($('.spd-kk__kurv') || {}).href || R + 'cart';
      box.innerHTML = vis.map(function (it) {
        return '<div class="spd-kk-rad' + (nye && nye.indexOf(it.key) > -1 ? ' is-ny' : '') + '">' + linje(it) + '</div>';
      }).join('') + (foer.length ? '<div class="spd-kk__foer"><p class="spd-kk__foer-t">Allerede i kurven</p>' + foer.slice(0, max).map(linje).join('') +
        (rest > 0 ? '<a class="spd-kk__flere" href="' + esc(kurvUrl) + '">+ ' + rest + (rest === 1 ? ' vare mere' : ' varer mere') + ' i kurven</a>' : '') + '</div>' : '');
      var ny = all(box, '.is-ny');
      if (ny.length) window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { ny.forEach(function (n) { n.classList.add('is-ind'); }); }); });
    }
    function fragt(cart, foer) {
      var el = $('[data-spd-kk-fragt]');
      var f = fragtSum(cart), g = graense();
      if (!g || !f.sendes) { el.hidden = true; return f; }
      var nu = Math.min(1, f.sum / g), fra = Math.min(1, Math.max(0, foer) / g);
      var klar = f.sum >= g, lige = klar && foer < g;
      el.hidden = false;
      el.classList.remove('is-glad');
      el.innerHTML = '<span class="spd-kk-fragt__t">' + (klar
        ? '<span class="spd-kk-fragt__ok" aria-hidden="true">' + ikonOk + '</span><b>Du har fri fragt</b>'
        : '<span>Du mangler <b>' + money(g - f.sum) + '</b> for fri fragt</span>') + '</span>' +
        '<div class="spd-kk__maaler"><i style="transform:scaleX(' + fra + ')"></i></div>';
      if (lige) { void el.offsetWidth; el.classList.add('is-glad'); }
      var bar = el.querySelector('i');
      window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { bar.style.transform = 'scaleX(' + nu + ')'; }); });
      return f;
    }
    function sum(cart) {
      $('[data-spd-kk-antal]').textContent = 'I alt i kurven (' + cart.item_count + (cart.item_count === 1 ? ' vare)' : ' varer)');
      $('[data-spd-kk-total]').textContent = money(cart.total_price);
    }


    /* Billedet flyver fra knappen (eller fra det store billede) op i kurven i headeren */
    function kurvIkon() {
      var a = document.querySelector('[data-shd-kurv]') || document.querySelector('.header__icon--cart, a[href$="/cart"]');
      if (!a) return null;
      var sek = a.closest('.shd-sektion');
      if (sek && sek.classList.contains('is-skjult')) sek.classList.remove('is-skjult');
      var ikon = a.querySelector('svg') || a;
      var r = ikon.getBoundingClientRect();
      if (!r.width) return null;
      // Er headeren på vej ned igen, regnes der med dens plads, når den er kommet frem
      var dy = 0;
      if (sek) { var m = window.getComputedStyle(sek).transform; if (m && m !== 'none') dy = +m.split(',')[5] || 0; }
      var top = r.top - dy;
      if (top + r.height < 0 || top > window.innerHeight) return null;
      return { a: a, x: r.left + r.width / 2, y: top + r.height / 2, bund: (sek ? sek.getBoundingClientRect().bottom - dy : top + r.height + 12) };
    }
    function startSted(fra) {
      var el = fra && fra.getBoundingClientRect ? fra : null;
      if (!el && tryk && Date.now() - trykTid < 8000) el = tryk.closest('button, a, label, [role="button"]') || tryk;
      if (!el || !document.body.contains(el)) return null;
      var r = el.getBoundingClientRect();
      if (!r.width || r.bottom < 0 || r.top > window.innerHeight) return null;
      return r;
    }
    // Det store billede: et billede eller en boks med billeder (varekortets billede)
    function stortBillede(el) {
      if (!el || !el.getBoundingClientRect) return null;
      var im = el.tagName === 'IMG' ? el : el.querySelector('img');
      var src = im && (im.currentSrc || im.src);
      var r = el.getBoundingClientRect();
      if (!src || !r.width || r.bottom < 0 || r.top > window.innerHeight) return null;
      return { src: src, r: r };
    }
    function flyv(src, r, stor, maal) {
      return new Promise(function (done) {
        var w = stor ? r.width : 72, h = stor ? r.height : 90;
        if (!stor && r.width < 72) { w = 56; h = 70; }
        var x0 = r.left + r.width / 2 - w / 2, y0 = r.top + r.height / 2 - h / 2;
        var x1 = maal.x - w / 2, y1 = maal.y - h / 2;
        var s1 = Math.min(22 / w, 26 / h);
        var el = document.createElement('div');
        el.className = 'spd-flyv';
        el.style.width = w + 'px';
        el.style.height = h + 'px';
        el.innerHTML = '<span><img alt="" src="' + esc(src) + '"></span>';
        document.body.appendChild(el);
        var tid = stor ? 820 : 720;
        var ind = el.firstChild;
        var ax = el.animate([{ transform: 'translateX(' + x0 + 'px)' }, { transform: 'translateX(' + x0 + 'px)', offset: stor ? .16 : .08 }, { transform: 'translateX(' + x1 + 'px)' }],
          { duration: tid, easing: 'cubic-bezier(.45, 0, .7, .3)', fill: 'forwards' });
        ind.animate([
          { transform: 'translateY(' + y0 + 'px) scale(1)', opacity: stor ? 1 : 0 },
          { transform: 'translateY(' + (y0 - (stor ? 0 : 14)) + 'px) scale(' + (stor ? .9 : 1.04) + ')', opacity: 1, offset: stor ? .16 : .12 },
          { opacity: 1, offset: .84 },
          { transform: 'translateY(' + y1 + 'px) scale(' + s1 + ') rotate(-8deg)', opacity: 0 }
        ], { duration: tid, easing: 'cubic-bezier(.2, .65, .3, 1)', fill: 'forwards' });
        ax.onfinish = function () { el.remove(); done(); };
        window.setTimeout(function () { if (el.parentNode) { el.remove(); done(); } }, tid + 400);
      });
    }
    function hop(a) {
      if (!a || !a.animate || rolig.matches) return;
      var ikon = a.querySelector('svg') || a;
      ikon.animate([{ transform: 'none' }, { transform: 'translateY(-4px) rotate(-9deg)', offset: .35 }, { transform: 'translateY(1px) rotate(4deg)', offset: .7 }, { transform: 'none' }], { duration: 560, easing: 'cubic-bezier(.16, 1, .3, 1)' });
    }
    function announce(cart) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: opt.sektion || 'supermen-kurv-kort', data: { source: opt.kilde || 'supermen-kurv-kort', itemCount: cart.item_count, mini: false } } }));
    }
    function sig(it, cart) {
      if (meld) meld.textContent = (it ? navnDele(it.product_title, it.vendor, it.product_type).titel + ' er lagt i kurven. ' : 'Varen er lagt i kurven. ') + 'Kurven har ' + cart.item_count + (cart.item_count === 1 ? ' vare.' : ' varer.');
    }

    function visKort(cart, o) {
      var svar = o.svar;
      var nye = (svar && svar.items ? svar.items : []).map(function (it) { return it.key; }).filter(function (k, i, a) { return k && a.indexOf(k) === i; });
      if (!nye.length && cart.items[0]) nye = [cart.items[0].key];
      var tilfoejet = cart.items.filter(function (it) { return nye.indexOf(it.key) > -1; });
      var aaben = kk.classList.contains('is-aaben');
      opt = o;
      var foer = fragtSum(cart).sum - (svar && svar.items ? svar.items.reduce(function (s, it) { return s + (it.final_line_price || 0); }, 0) : 0);
      var flyveFra = startSted(o.fra);
      var maal = kurvIkon();
      var stor = flyveFra && maal ? stortBillede(o.stort) : null;
      var src = stor ? stor.src : (tilfoejet[0] && tilfoejet[0].image ? billede(tilfoejet[0].image, 200) : '');
      var rejse = !rolig.matches && flyveFra && maal && src
        ? flyv(src, stor ? stor.r : flyveFra, !!stor, maal)
        : Promise.resolve();
      return Promise.all([rejse, hentNormal(cart)]).then(function () {
        announce(cart);
        if (maal) hop(maal.a);
        noegler = aaben ? nye.concat(noegler.filter(function (k) { return nye.indexOf(k) < 0; })) : nye.slice();
        if (!aaben) aabn(maal);
        linjer(cart, aaben ? nye : null);
        fragt(cart, foer);
        sum(cart);
        sig(tilfoejet[0], cart);
      });
    }
    function aabn(maal) {
      retur = document.activeElement;
      if (!mobil.matches) {
        var top = maal ? Math.max(12, maal.bund + 10) : 16;
        var hojre = maal ? Math.max(12, window.innerWidth - maal.x - 28) : 20;
        kk.style.setProperty('--kk-top', top + 'px');
        kk.style.setProperty('--kk-hojre', hojre + 'px');
        kk.classList.toggle('uden-pil', !maal || hojre === 12);
      }
      kk.style.removeProperty('--kk-traek');
      kk.classList.add('is-aaben');
      kk.setAttribute('aria-hidden', 'false');
      kk.setAttribute('aria-modal', mobil.matches ? 'true' : 'false');
      if (skygge) skygge.classList.add('is-aaben');
      window.setTimeout(function () { if (kk.classList.contains('is-aaben')) kk.focus({ preventScroll: true }); }, 80);
    }
    function luk() {
      if (!kk || !kk.classList.contains('is-aaben')) return;
      kk.classList.remove('is-aaben', 'is-traek');
      kk.setAttribute('aria-hidden', 'true');
      if (skygge) skygge.classList.remove('is-aaben');
      if (kk.contains(document.activeElement) && retur && retur.focus && document.body.contains(retur)) retur.focus({ preventScroll: true });
    }

    function bind() {
      all(kk, '[data-spd-kk-luk]').forEach(function (b) { b.addEventListener('click', luk); });
      if (skygge) skygge.addEventListener('click', luk);
      // Mobil: kortet kan trækkes ned for at lukke det
      var traek = kk.querySelector('[data-spd-kk-traek]'), y0 = null, dy = 0;
      traek.addEventListener('pointerdown', function (e) {
        if (!mobil.matches || e.target.closest('button')) return;
        y0 = e.clientY; dy = 0;
        kk.classList.add('is-traek');
        traek.setPointerCapture(e.pointerId);
      });
      traek.addEventListener('pointermove', function (e) {
        if (y0 == null) return;
        dy = Math.max(0, e.clientY - y0);
        kk.style.setProperty('--kk-traek', dy + 'px');
      });
      function slip() {
        if (y0 == null) return;
        y0 = null;
        kk.classList.remove('is-traek');
        if (dy > 70) luk(); else kk.style.removeProperty('--kk-traek');
      }
      traek.addEventListener('pointerup', slip);
      traek.addEventListener('pointercancel', slip);
    }
    // Klik uden for kortet lukker det. Knapper, der lægger i kurven, lader det blive.
    document.addEventListener('click', function (e) {
      if (!kk || !kk.classList.contains('is-aaben') || kk.contains(e.target) || !e.target.isConnected) return;
      if (e.target.closest('[data-spd-atc], [data-spd-mbar-btn], [data-spd-add], [data-spd-aabn], .spd-kort__hurtig')) return;
      luk();
    });
    document.addEventListener('keydown', function (e) {
      if (!kk || !kk.classList.contains('is-aaben')) return;
      if (e.key === 'Escape') { luk(); return; }
      // På mobil dækker kortet siden, så fokus bliver i kortet
      if (e.key === 'Tab' && mobil.matches) {
        var f = all(kk, 'a[href], button:not([disabled])').filter(function (x) { return x.offsetParent !== null; });
        if (!f.length) return;
        if (e.shiftKey && (document.activeElement === f[0] || document.activeElement === kk)) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
    if (mobil.addEventListener) mobil.addEventListener('change', luk);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', find); else find();

    window.SupermenKurvKort = {
      // Kan kortet vises? hvor: 'kort' for varekortene, som kan slås fra på headerens kurv
      klar: function (hvor) {
        var r = find();
        return !!r && !(hvor === 'kort' && r.dataset.kort === 'false');
      },
      /* o.svar: svaret fra /cart/add.js · o.cart: hele kurven bagefter · o.fra: knappen, der blev trykket på
         o.stort: billedet (eller billedboksen), der flyver i stedet for et lille billede · o.fri: fri fragt i øre
         o.kilde og o.sektion til cart:update (o.forslag, o.udeluk og o.efter bruges ikke længere, men må gerne sendes med) */
      vis: function (o) {
        o = o || {};
        if (!find()) return Promise.reject(new Error('Kortet findes ikke på siden'));
        return (o.cart ? Promise.resolve(o.cart) : hentKurv()).then(function (cart) { return visKort(cart, o); });
      },
      luk: luk,
      // Kortet viser ingen forslag mere. Varesiden spørger stadig, så den får en tom liste uden at hente noget.
      anbefal: function () { return Promise.resolve([]); }
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["supermen-spor"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.SupermenSpor) return;
    window.SupermenSpor = true;
    var roligt = window.matchMedia('(prefers-reduced-motion: reduce)');
    /* Måleren under en vandret række kan trækkes med musen eller fingeren.
       Samme kode står i supermen-vare, product-list og supermen-spor, fordi Shopify kun henter JavaScript fra filer,
       der bruges på siden. Den første, der kommer, definerer den. Stilen står i supermen-spor. */
    if (!window.SupermenTraek) window.SupermenTraek = function (maaler, spor) {
      if (!maaler || !spor || maaler._traek || !maaler.firstElementChild) return;
      maaler._traek = true;
      maaler.classList.add('spd-traek');
      var tommel = maaler.firstElementChild, greb = 0, aktiv = false, snap = '', tSnap = 0;
      var rolig = window.matchMedia('(prefers-reduced-motion: reduce)');
      function til(x) {
        var r = maaler.getBoundingClientRect(), t = tommel.getBoundingClientRect(), plads = r.width - t.width;
        if (plads <= 0) return;
        spor.scrollLeft = Math.max(0, Math.min(1, (x - greb - r.left) / plads)) * (spor.scrollWidth - spor.clientWidth);
      }
      // Når man slipper, glider rækken til det nærmeste kort, så kortene står lige
      function naermeste() {
        var max = spor.scrollWidth - spor.clientWidth, nu = spor.scrollLeft, bedst = nu, afst = Infinity;
        var pad = parseFloat(window.getComputedStyle(spor).scrollPaddingLeft) || 0, kant = spor.getBoundingClientRect().left + pad;
        var muligt = [0, max];
        Array.prototype.forEach.call(spor.children, function (k) { muligt.push(nu + k.getBoundingClientRect().left - kant); });
        muligt.forEach(function (x) { x = Math.max(0, Math.min(max, x)); if (Math.abs(x - nu) < afst) { afst = Math.abs(x - nu); bedst = x; } });
        return bedst;
      }
      maaler.addEventListener('pointerdown', function (e) {
        if ((e.pointerType === 'mouse' && e.button !== 0) || spor.scrollWidth <= spor.clientWidth + 2) return;
        var t = tommel.getBoundingClientRect();
        greb = e.clientX >= t.left && e.clientX <= t.right ? e.clientX - t.left : t.width / 2;
        clearTimeout(tSnap);
        if (!aktiv) snap = spor.style.scrollSnapType;
        aktiv = true;
        spor.style.scrollSnapType = 'none';
        spor.style.scrollBehavior = 'auto';
        maaler.classList.add('is-traek');
        try { maaler.setPointerCapture(e.pointerId); } catch (err) {}
        e.preventDefault();
        til(e.clientX);
      });
      maaler.addEventListener('pointermove', function (e) { if (aktiv) til(e.clientX); });
      function slip() {
        if (!aktiv) return;
        aktiv = false;
        maaler.classList.remove('is-traek');
        spor.style.scrollBehavior = '';
        spor.scrollTo({ left: naermeste(), behavior: rolig.matches ? 'auto' : 'smooth' });
        tSnap = setTimeout(function () { spor.style.scrollSnapType = snap; }, 500);
      }
      maaler.addEventListener('pointerup', slip);
      maaler.addEventListener('pointercancel', slip);
      maaler.addEventListener('lostpointercapture', slip);
    };

    function maal(root) {
      var spor = root.querySelector('[data-sp-spor]'), nav = root.querySelector('[data-sp-nav]'), maaler = root.querySelector('[data-sp-maaler]');
      if (!spor) return;
      var ruller = spor.scrollWidth > spor.clientWidth + 2;
      if (nav) nav.hidden = !ruller;
      if (maaler) maaler.hidden = !ruller;
      if (!ruller) return;
      var max = spor.scrollWidth - spor.clientWidth;
      var x = Math.max(0, Math.min(spor.scrollLeft, max));
      if (nav) {
        nav.querySelector('[data-sp-dir="-1"]').disabled = x <= 2;
        nav.querySelector('[data-sp-dir="1"]').disabled = x >= max - 2;
      }
      if (maaler) {
        var s = spor.clientWidth / spor.scrollWidth;
        var t = maaler.querySelector('[data-sp-tommel]');
        t.style.setProperty('--sp-s', s.toFixed(4));
        t.style.setProperty('--sp-x', ((x / max) * (1 - s) * 100).toFixed(2) + '%');
      }
    }
    // Et klik flytter rækken så mange hele kort, som der er plads til
    function skridt(spor) {
      var el = spor.firstElementChild;
      if (!el) return spor.clientWidth;
      var gap = parseFloat(window.getComputedStyle(spor).columnGap) || 0;
      var w = el.getBoundingClientRect().width + gap;
      return Math.max(1, Math.floor((spor.clientWidth + gap) / w)) * w;
    }
    function init(scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('[data-sp]'), function (root) {
        if (root._sp) { maal(root); return; }
        var spor = root.querySelector('[data-sp-spor]');
        if (!spor) return;
        root._sp = true;
        window.SupermenTraek(root.querySelector('[data-sp-maaler]'), spor);
        var t = 0;
        spor.addEventListener('scroll', function () {
          if (t) return;
          t = window.requestAnimationFrame(function () { t = 0; maal(root); });
        }, { passive: true });
        if ('ResizeObserver' in window) new window.ResizeObserver(function () { maal(root); }).observe(spor);
        maal(root);
      });
    }
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-sp-dir]');
      if (!b) return;
      var root = b.closest('[data-sp]'), spor = root && root.querySelector('[data-sp-spor]');
      if (!spor) return;
      spor.scrollBy({ left: skridt(spor) * parseInt(b.dataset.spDir, 10), behavior: roligt.matches ? 'auto' : 'smooth' });
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["supermen-tyvstart-kort"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.SupermenKortStr) return;
    window.SupermenKortStr = true;
    // Baren under billederne følger med, når man swiper
    document.addEventListener('scroll', function (e) {
      var l = e.target;
      if (!l.classList || !l.classList.contains('spd-kort__link--glid')) return;
      l.classList.add('er-vist');
      var bar = l.parentNode.querySelector('.spd-kort__bar');
      if (bar && l.clientWidth) bar.style.setProperty('--i', Math.round(l.scrollLeft / l.clientWidth));
    }, { capture: true, passive: true });
    // Rører man ved billedet, hentes resten af billederne, før man når at swipe
    function rort(e) {
      var l = e.target.closest && e.target.closest('.spd-kort__link--glid');
      if (l) l.classList.add('er-vist');
    }
    document.addEventListener('touchstart', rort, { capture: true, passive: true });
    document.addEventListener('pointerdown', rort, { capture: true, passive: true });
    // Størrelserne ligger gemt bag pilen nederst på billedet, så varen kan ses i ro
    function aabn(kort, vis, fokus) {
      if (!kort) return;
      var knap = kort.querySelector('[data-spd-aabn]');
      kort.classList.toggle('is-str', vis);
      if (knap) knap.setAttribute('aria-expanded', vis ? 'true' : 'false');
      if (!fokus) return;
      if (vis) { var f = kort.querySelector('.spd-kort__str button:not([disabled])'); if (f) f.focus({ preventScroll: true }); }
      else if (knap) knap.focus({ preventScroll: true });
    }
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      // Fokus flyttes kun ved tastatur (detail 0), så en række ikke ruller væk under musen
      var a = e.target.closest('[data-spd-aabn]');
      if (a) { e.preventDefault(); aabn(a.closest('.spd-kort'), true, e.detail === 0); return; }
      var l = e.target.closest('[data-spd-luk]');
      if (l) { e.preventDefault(); aabn(l.closest('.spd-kort'), false, e.detail === 0); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !e.target.closest) return;
      var kort = e.target.closest('.spd-kort.is-str');
      if (kort) { e.preventDefault(); aabn(kort, false, true); }
    });
    // Lukker igen, når musen eller fokus forlader kortet
    document.addEventListener('mouseout', function (e) {
      // Ikke mens en knap holdes nede: rækkerne fanger musen, når man trækker i dem
      if (e.buttons) return;
      var kort = e.target.closest && e.target.closest('.spd-kort.is-str');
      if (!kort || (e.relatedTarget && kort.contains(e.relatedTarget))) return;
      var tast = document.activeElement && kort.contains(document.activeElement) && document.activeElement.matches(':focus-visible');
      if (tast) return;
      setTimeout(function () { if (!kort.matches(':hover')) aabn(kort, false, false); }, 200);
    });
    document.addEventListener('focusout', function (e) {
      var kort = e.target.closest && e.target.closest('.spd-kort.is-str');
      if (kort && e.relatedTarget && !kort.contains(e.relatedTarget)) aabn(kort, false, false);
    });
    // Størrelsen vælges først; knappen "Læg i kurv" får så varianten og lægger den i kurven
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.spd-kort__hurtig [data-spd-valg]');
      if (!b || b.disabled) return;
      e.preventDefault();
      var g = b.closest('.spd-kort__hurtig');
      Array.prototype.forEach.call(g.querySelectorAll('[data-spd-valg]'), function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      var knap = g.querySelector('.spd-kort__laeg');
      knap.dataset.spdAdd = b.dataset.spdValg;
      knap.dataset.spdValgNavn = b.textContent.trim();
      knap.disabled = false;
      knap.classList.remove('is-ok');
      knap.setAttribute('aria-label', 'Læg ' + (g.dataset.navn || '') + ', ' + b.textContent.trim() + ' i kurven');
    });

    /* Læg i kurv fra kortet virker på alle sider, også forsiden og søgesiden.
       På produktsiden glider kurven ind. Andre steder åbner headerens mini-kurv, eller der kommer en kort besked. */
    var R = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    function esc(s) {
      return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
    }
    var besked, beskedT;
    function vis(html, fejl) {
      if (!besked) {
        besked = document.createElement('div');
        besked.className = 'spd spd-toast';
        besked.setAttribute('role', 'status');
        besked.setAttribute('aria-live', 'polite');
        document.body.appendChild(besked);
      }
      besked.innerHTML = html;
      besked.classList.toggle('is-fejl', !!fejl);
      void besked.offsetWidth;
      besked.classList.add('is-vist');
      window.clearTimeout(beskedT);
      beskedT = window.setTimeout(function () { besked.classList.remove('is-vist'); }, 4500);
    }
    function tilfoej(knap) {
      if (knap.classList.contains('is-busy')) return;
      var kort = knap.closest('.spd-kort');
      var navn = kort && kort.querySelector('.spd-kort__navn');
      navn = navn && navn.firstChild ? navn.firstChild.textContent.trim() : '';
      var items = [{ id: +knap.dataset.spdAdd, quantity: 1 }];
      knap.classList.add('is-busy');
      function ok() {
        knap.classList.remove('is-busy');
        knap.classList.add('is-ok');
        window.setTimeout(function () { knap.classList.remove('is-ok'); }, 2400);
      }
      function fejl(msg) {
        knap.classList.remove('is-busy');
        vis(esc(msg || 'Varen kunne ikke lægges i kurven. Prøv igen.'), true);
      }
      if (document.querySelector('[data-spd-vare][data-ready]')) {
        document.dispatchEvent(new CustomEvent('supermen:add', { detail: { items: items, onSuccess: ok, onError: fejl } }));
        return;
      }
      fetch(R + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || 'Varen kunne ikke lægges i kurven. Prøv igen.');
        });
      }).then(function () {
        // Varen er lagt i kurven nu. Fejler hentningen af kurven bagefter, vises beskeden alligevel.
        return fetch(R + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).catch(function () { return null; });
      }).then(function (cart) {
        ok();
        var str = knap.dataset.spdValgNavn ? ', ' + knap.dataset.spdValgNavn : '';
        // Headerens mini-kurv viser varen, når headeren kan ses (Supermen header). Ellers kommer beskeden.
        var mk = document.querySelector('[data-shd-minikurv][data-ved-tilfoej="true"]');
        var mkBar = mk && mk.closest('[data-shd-bar]');
        var mini = !!(cart && mkBar && mkBar.getBoundingClientRect().bottom > 0);
        if (cart) document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'supermen-kort', data: { source: 'supermen-kort', itemCount: cart.item_count, navn: navn + str, mini: mini } } }));
        if (!mini) vis('<svg class="spd-ikon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg><span>' + esc(navn + str) + ' er lagt i kurven.</span><a href="' + R + 'cart">Se kurven</a>');
      }).catch(function (e) { fejl(e instanceof TypeError ? 'Varen kunne ikke lægges i kurven. Tjek din forbindelse, og prøv igen.' : e.message); });
    }
    document.addEventListener('click', function (e) {
      var k = e.target.closest && e.target.closest('.spd-kort [data-spd-add]');
      if (!k || k.disabled || !k.dataset.spdAdd) return;
      // Rækkerne på produktsiden klarer det selv. Det samme gør den ældre kode i blokken Produktkort, hvis den stadig er i temaet.
      if (k.closest('[data-spd-mere]') || window.SupermenKortblok === true) return;
      e.preventDefault();
      tilfoej(k);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
